export const resgisterDegree = [
  {
    name: 'BS',
    value: 'BS',
  },
  {
    name: 'DS',
    value: 'DS',
  },
  {
    name: 'CN',
    value: 'CN',
  },
  {
    name: 'SV',
    value: 'SV',
  },
  {
    name: 'Khác',
    value: 'null',
  },
];

export const degree = [
  {
    name: 'GS',
    value: 'GS',
  },
  {
    name: 'GS.TS',
    value: 'GS.TS',
  },
  {
    name: 'GS.TS.BS',
    value: 'GS.TS.BS',
  },
  {
    name: 'GS.TS.BSCKI',
    value: 'GS.TS.BSCKI',
  },
  {
    name: 'GS.TS.BSCKII',
    value: 'GS.TS.BSCKII',
  },
  {
    name: 'PGS',
    value: 'PGS',
  },
  {
    name: 'PGS.TS',
    value: 'PGS.TS',
  },
  {
    name: 'PGS.TS.BS',
    value: 'PGS.TS.BS',
  },
  {
    name: 'PGS.TS.BSCKI',
    value: 'PGS.TS.BSCKI',
  },
  {
    name: 'PGS.TS.BSCKII',
    value: 'PGS.TS.BSCKII',
  },
  {
    name: 'TS',
    value: 'TS',
  },
  {
    name: 'TS.BS',
    value: 'TS.BS',
  },
  {
    name: 'TS.BSCKI',
    value: 'TS.BSCKI',
  },
  {
    name: 'TS.BSCKII',
    value: 'TS.BSCKII',
  },
  {
    name: 'ThS',
    value: 'ThS',
  },
  {
    name: 'ThS.BS',
    value: 'ThS.BS',
  },
  {
    name: 'ThS.BSCKI',
    value: 'ThS.BSCKI',
  },
  {
    name: 'ThS.BSCKII',
    value: 'ThS.BSCKII',
  },
  {
    name: 'BSCKI',
    value: 'BSCKI',
  },
  {
    name: 'BSCKII',
    value: 'BSCKII',
  },
  {
    name: 'BSNT',
    value: 'BSNT',
  },
  ...resgisterDegree,
];
